import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-hyperlink-button',
  templateUrl: './hyperlink-button.component.html',
  styleUrls: ['./hyperlink-button.component.scss'],
})
export class HyperlinkButtonComponent {
  @Input() public buttonIconPath: string;
  @Input() public buttonTextPath: string;
  @Output() public buttonClickedEventEmitter = new EventEmitter<undefined>();

  public buttonClicked() {
    this.buttonClickedEventEmitter.emit();
  }
}
